<template>
  <!-- <div class="header-wrap" :style="{ display: isApp ? 'none' : 'block' }"> -->
  <!-- 暂时先全部隐藏头部 -->
  <div class="header-wrap" style="display: none">
    <div class="header">
      <van-icon name="arrow-left" class="back" @click="onBack" />
      <span class="title">{{ $route.meta.title }}</span>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Header',
  props: {
    title: {
      type: String,
      default: '恒驰汽车',
    },
  },
  data() {
    return {
      isApp: hcApp.isHCApp(),
    }
  },
  methods: {
    onBack() {
      this.mixinGoBack()
    },
  },
}
</script>
<style lang="scss" scoped>
.header-wrap {
  background: white;
  .header {
    position: relative;
    height: 60px;
    display: flex;
    align-items: center;
    .back {
      padding: 0 32px;
      font-size: 40px;
      color: #333333;
    }
    .title {
      position: absolute;
      top: 0;
      left: 50%;
      transform: translateX(-50%);
      line-height: 60px;
      font-size: 30px;
      font-weight: 400;
      color: #333333;
    }
  }
}
</style>
